import {Injectable} from '@angular/core';
import {HttpRequest} from '@angular/common/http';
import {BehaviorSubject, Observable, Subject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PendingConfiguratorRequestService {
  private pendingRequests: Set<HttpRequest<unknown>> = new Set<HttpRequest<unknown>>();
  private hasPendingRequestsSubject: Subject<boolean> = new BehaviorSubject<boolean>(false);
  private updateFlag: boolean = false;

  public setUpdateFlag(value: boolean): void {
    this.updateFlag = value;
    this.updateSubject();
  }

  public getUpdateFlag(): boolean {
    return this.updateFlag;
  }

  public addPendingRequest(request: HttpRequest<unknown>): void {
    this.pendingRequests.add(request);
    this.updateFlag = false;
    this.updateSubject();
  }

  public removePendingRequest(request: HttpRequest<unknown>): void {
    this.pendingRequests.delete(request);
    this.updateSubject();
  }

  public hasPendingRequests(): Observable<boolean> {
    return this.hasPendingRequestsSubject.asObservable().pipe(distinctUntilChanged());
  }

  private updateSubject(): void {
    const next = this.getUpdateFlag() || !!this.pendingRequests.size;
    this.hasPendingRequestsSubject.next(next);
  }
}
